import React, { useRef, useEffect } from 'react'

const Drumpad = props => {
  const padRef = useRef()

  const activatePad = (e) => {
    let pad = padRef.current
    console.log(pad)
    if ((e.type === 'mousedown' ||
      e.type === 'touchstart' ||
      (e.type === 'keydown' && e.keyCode === props.soundset.key))
      && !pad.classList.contains('drumforfun-active')) {
      pad.classList.add('drumforfun-active')
      pad.querySelector('.drumforfun-clip').currentTime = 0
      pad.querySelector('.drumforfun-clip').play()
      props.display(props.soundset.label)
    }
  }

  const deactivatePad = () => {
    let pad = padRef.current
    if (pad.classList.contains('drumforfun-active')) {
      pad.classList.remove('drumforfun-active')
      props.display('')
    }
  }

  useEffect(() => {
    document.addEventListener('keydown', activatePad)
    document.addEventListener('keyup', deactivatePad)
    return () => {
      document.removeEventListener('keydown', activatePad)
      document.removeEventListener('keyup', deactivatePad)
    }
  }, [])

  return (
    <div
      ref={padRef}
      className='drumforfun-drum-pad'
      id={props.soundset.label}
      onTouchStart={activatePad}
      onTouchEnd={deactivatePad}
      onMouseDown={activatePad}
      onMouseUp={deactivatePad}
    >
      {props.soundset.id}
      <audio
        className='drumforfun-clip'
        id={props.soundset.id}
        src={props.soundset.url}
      />
    </div>
  )
}

export default Drumpad